import React from 'react';
import { colors, Grid } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';

const styles = (theme) => createStyles({
  root: {
    paddingBottom: '30px',
    [theme.breakpoints.down('md')]: {
      borderBottom: `1px solid ${colors.grey[300]}`,
      paddingBottom: '20px',
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px',
    },
  },
});

export const IndentedWrapper = withStyles(styles)(({ ...props }: any) => {
  const { children, classes } = props;
  return (
    <div className={classes.root}>
      <Grid container classes={{ container: 'indent' }}>
        {children}
      </Grid>
    </div>
  );
});
